import classNames from 'classnames';
import * as React from 'react';
import './style.scss';

export interface IInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  title?: string;
  before?: React.ReactNode;
  after?: React.ReactNode;
  status?: 'default' | 'error';
  bottom?: string;
}

export default class Input extends React.Component<IInputProps> {
  static defaultProps = {
    disabled: false,
    status: 'default',
    before: null,
    after: null,
    bottom: '',
    title: '',
  };

  public render() {
    const { onChange, before, after, bottom, status, title, disabled, ...props } = this.props;

    return (
      <div
        className={classNames(`input d-flex flex-column`, {
          'input-status-error': status === 'error',
          'input-status-disabled': disabled,
        })}>
        {title && <div className="input-title">{title}</div>}
        <div className={'input-field d-flex flex-row'}>
          {before && <div className="input-before">{before}</div>}
          <input disabled={disabled} {...props} onChange={onChange} className="flex-1" />
          {after && <div className="input-after">{after}</div>}
        </div>
        {bottom && <div className="input-bottom">{bottom}</div>}
      </div>
    );
  }
}
